const STORAGE_KEYS = {
  USERS: 'marathon-tracker-users',
  ROUTES: 'marathon-tracker-routes',
  CHECKPOINTS: 'marathon-tracker-checkpoints'
};

export const api = {
  // ユーザー関連
  async getUsers() {
    try {
      const data = localStorage.getItem(STORAGE_KEYS.USERS);
      return data ? JSON.parse(data) : [];
    } catch (error) {
      console.error('Storage Error:', error);
      return [];
    }
  },

  async saveUser(user: any) {
    try {
      const users = await this.getUsers();
      const index = users.findIndex((u: any) => u.id === user.id);
      if (index >= 0) {
        users[index] = user;
      } else {
        users.push(user);
      }
      localStorage.setItem(STORAGE_KEYS.USERS, JSON.stringify(users));
      return { success: true, data: user };
    } catch (error) {
      console.error('Storage Error:', error);
      throw new Error('ユーザーの保存に失敗しました');
    }
  },

  async deleteUser(id: string) {
    try {
      const users = await this.getUsers();
      const filtered = users.filter((u: any) => u.id !== id);
      localStorage.setItem(STORAGE_KEYS.USERS, JSON.stringify(filtered));
      return { success: true };
    } catch (error) {
      console.error('Storage Error:', error);
      throw new Error('ユーザーの削除に失敗しました');
    }
  },

  // ルート関連
  async getRoutes() {
    try {
      const data = localStorage.getItem(STORAGE_KEYS.ROUTES);
      return data ? JSON.parse(data) : [];
    } catch (error) {
      console.error('Storage Error:', error);
      return [];
    }
  },

  async saveRoute(route: any) {
    try {
      const routes = await this.getRoutes();
      const index = routes.findIndex((r: any) => r.id === route.id);
      if (index >= 0) {
        routes[index] = route;
      } else {
        routes.push(route);
      }
      localStorage.setItem(STORAGE_KEYS.ROUTES, JSON.stringify(routes));
      return { success: true, data: route };
    } catch (error) {
      console.error('Storage Error:', error);
      throw new Error('ルートの保存に失敗しました');
    }
  },

  async deleteRoute(id: string) {
    try {
      const routes = await this.getRoutes();
      const filtered = routes.filter((r: any) => r.id !== id);
      localStorage.setItem(STORAGE_KEYS.ROUTES, JSON.stringify(filtered));
      return { success: true };
    } catch (error) {
      console.error('Storage Error:', error);
      throw new Error('ルートの削除に失敗しました');
    }
  },

  // チェックポイント関連
  async saveCheckpoint(checkpoint: any) {
    try {
      const routes = await this.getRoutes();
      const route = routes.find((r: any) => r.id === checkpoint.routeId);
      if (!route) {
        throw new Error('Route not found');
      }

      const checkpointIndex = route.checkpoints.findIndex((c: any) => c.id === checkpoint.id);
      if (checkpointIndex >= 0) {
        route.checkpoints[checkpointIndex] = checkpoint;
      } else {
        route.checkpoints.push(checkpoint);
      }

      await this.saveRoute(route);
      return { success: true, data: checkpoint };
    } catch (error) {
      console.error('Storage Error:', error);
      throw new Error('チェックポイントの保存に失敗しました');
    }
  },

  async deleteCheckpoint(id: string) {
    try {
      const routes = await this.getRoutes();
      for (const route of routes) {
        const index = route.checkpoints.findIndex((c: any) => c.id === id);
        if (index >= 0) {
          route.checkpoints.splice(index, 1);
          await this.saveRoute(route);
          break;
        }
      }
      return { success: true };
    } catch (error) {
      console.error('Storage Error:', error);
      throw new Error('チェックポイントの削除に失敗しました');
    }
  }
};